export default {"src":"/_next/static/media/feeling-support.mono.e6f0b7f3.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};